import './App.css';
import AllRoutes from './Components/AllRoutes';

function App() {
  return (
    <>
      <AllRoutes />
    </>
  );
}

export default App;
